import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mobile-upload-expired-error',
  templateUrl: './mobile-upload-expired.component.html',
  styleUrls: ['./mobile-upload-expired.component.scss'],
  standalone: false,
})
export class MobileUploadExpiredComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
